import axiosInstance from '../services/AxiosInstance';

/**
 * Relative API path for a task/comment attachment (axios baseURL already includes /api).
 */
export function taskAttachmentPath(fileId) {
  return `/task/attachments/${fileId}`;
}

/**
 * Fetch file bytes using the same auth / refresh behavior as the rest of the app.
 * @param {number} fileId — files.id from task or comment attachment
 * @returns {Promise<Blob>}
 */
export async function fetchTaskAttachmentBlob(fileId) {
  const res = await axiosInstance.get(taskAttachmentPath(fileId), {
    responseType: 'blob',
  });
  return res.data;
}

/**
 * Open attachment in a new tab (blob URL; revoked after delay).
 */
export async function openTaskAttachmentInNewTab(fileId) {
  const blob = await fetchTaskAttachmentBlob(fileId);
  const objectUrl = URL.createObjectURL(blob);
  const w = window.open(objectUrl, '_blank', 'noopener,noreferrer');
  if (!w) {
    URL.revokeObjectURL(objectUrl);
  }
  setTimeout(() => URL.revokeObjectURL(objectUrl), 120000);
}

/**
 * Trigger browser download with a suggested filename.
 */
export async function downloadTaskAttachment(fileId, suggestedFileName) {
  const blob = await fetchTaskAttachmentBlob(fileId);
  const objectUrl = URL.createObjectURL(blob);
  try {
    const a = document.createElement('a');
    a.href = objectUrl;
    a.download = suggestedFileName || 'download';
    a.rel = 'noopener';
    document.body.appendChild(a);
    a.click();
    a.remove();
  } finally {
    setTimeout(() => URL.revokeObjectURL(objectUrl), 60000);
  }
}
